export const SIGN_IN_REQUEST = "SIGN_IN_REQUEST";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";

export const CLEAR_ERROR = "CLEAR_ERROR";

export const GET_WORKSPACE_REQUEST = "GET_WORKSPACE_REQUEST";
export const GET_WORKSPACE_SUCCESS = "GET_WORKSPACE_SUCCESS";
export const GET_WORKSPACE_ERROR = "GET_WORKSPACE_ERROR";